module.exports = __webpack_public_path__ + "img/header-bg.010f0044.png";